import React from "react";
import SbuxStyledTableCell from "../../../../../components/SbuxTable/SbuxStyledTableCell";
import { useAppSelector } from "../../../../../store/types";
import SbuxStyledTableRow from "../../../../../components/SbuxTable/SbuxStyledTableRow";
import SbuxTooltip from "../../../../../components/SbuxTooltip";
import { Box, IconButton } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { ellipse, getTitleForEllipse } from "../../../../../utils/stringUtil";
import { getLastUpdated } from "../../../utils";
import { formatTimeString } from "../../../../../utils/dateUtil";
import styles from "../../styles";
import useCss from "../../../../../hooks/useCss";
import { getTimezoneSelector } from "../../../../../selectors/settingsSelector";

interface ClosureMsgRowProps {
  row: Record<string, unknown>;
  handleEditRowClick: (row: Record<string, unknown>) => void;
}

const ClosureMsgRow = ({ row, handleEditRowClick }: ClosureMsgRowProps) => {
  const classes = useCss(styles);
  const timezone = useAppSelector(getTimezoneSelector);

  const getSingleInstance = () => {
    return row.type !== "Single" ? (
      <IconButton
        disableFocusRipple
        disableRipple
        sx={{
          cursor: "pointer",
          fontSize: 13,
          height: 12,
          color: "inherit",
          "&:focus": {
            outline: 0,
          },
          "&.MuiIconButton-root": {
            padding: 0,
          },
        }}
      >
        <Box sx={{ display: "flex" }}>
          <Box sx={{ flex: 1, marginRight: 1 }}>
            {row.category as React.ReactNode}
          </Box>
          <Box sx={{ flex: 1 }}>
            <CalendarTodayIcon sx={{ fontSize: 14 }} />
          </Box>
        </Box>
      </IconButton>
    ) : (
      <Box sx={{ fontSize: 13 }}>{row.category as React.ReactNode}</Box>
    );
  };

  const handleEditClick = () => {
    handleEditRowClick(row);
  };
  return (
    <>
      <SbuxStyledTableRow isHighlighted={row.highLight as boolean | undefined}>
        <SbuxStyledTableCell
          className={classes.cellFocus}
          onClick={handleEditClick}
        >
          {row["groupName"] as React.ReactNode}
        </SbuxStyledTableCell>
        <SbuxTooltip
          title={getTitleForEllipse(
            row.description as string | null | undefined,
          )}
          offset={[-10, 0]}
          placement="right-end"
        >
          <SbuxStyledTableCell
            className={classes.cellFocus}
            onClick={handleEditClick}
          >
            {ellipse(
              row["description"] as string,
              process.env.REACT_APP_COLUMN_LENGTH_BEFORE_ELLIPSIS
                ? parseInt(
                    process.env.REACT_APP_COLUMN_LENGTH_BEFORE_ELLIPSIS,
                    10,
                  )
                : undefined,
            )}
          </SbuxStyledTableCell>
        </SbuxTooltip>
        <SbuxStyledTableCell
          className={classes.cellFocus}
          onClick={handleEditClick}
        >
          {getSingleInstance()}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell
          className={classes.cellFocus}
          onClick={handleEditClick}
        >
          {row["startDate"] as React.ReactNode}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell
          className={classes.cellFocus}
          onClick={handleEditClick}
        >
          {formatTimeString(row["startTime"] as string | undefined)}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell
          className={classes.cellFocus}
          onClick={handleEditClick}
        >
          {row["endDate"] as React.ReactNode}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell
          className={classes.cellFocus}
          onClick={handleEditClick}
        >
          {formatTimeString(row["endTime"] as string | undefined)}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell
          className={classes.cellFocus}
          onClick={handleEditClick}
        >
          {row["status"] as React.ReactNode}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell
          className={classes.cellFocus}
          onClick={handleEditClick}
        >
          {getLastUpdated(row, timezone)}
        </SbuxStyledTableCell>
      </SbuxStyledTableRow>
    </>
  );
};

export default ClosureMsgRow;
